import { debounce, isNil } from 'lodash-es';

export default {
  props: {
    //* id of input
    // required
    inputId: {
      type: String,
      required: true,
      default: '0',
    },
    //* label for input
    // required
    label: {
      type: String,
      required: true,
      default: '',
    },
    //* Placeholder for input
    placeholder: {
      type: String,
      default: 'Assurup',
    },
    //* enable/disable input
    inputDisabled: {
      type: Boolean,
      default: false,
    },
    //* validate/invalidate input
    inputValidation: {
      type: Function,
      default: (value) => (!value ? null : true),
    },
    //* error message to display when validation is incorrect
    errorMessage: {
      type: String,
      default: 'Veuillez compléter le champ',
    },
    //* name of module to be called in store
    moduleName: {
      type: String,
      default: 'risk',
    },
    //* name of setter's action in store
    setterName: {
      type: String,
      default: 'setValueWithPath',
    },
    //* name of getter in store
    // required
    getterName: {
      type: String,
      required: true,
      default: 'undefined',
    },
    //* wrapping function to get object
    getterFunction: {
      type: Function,
      default: (value) => value,
    },
    //* wrapping function to set object
    setterFunction: {
      type: Function,
      default: (value, path) => ({ value, path }),
    },
    //* function to call when setter is done
    setterCallback: {
      type: Function,
      default: () => {},
    },
    //* time in milliseconds to set value in store
    debounceTimer: {
      type: Number,
      default: 500,
    },
    path: {
      type: [String, null],
      default: null,
    },
    forceValidation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      customValue: '',
      debouncer: ({ cancel: () => {} }),
    };
  },
  computed: {
    storeValue() {
      return this.getterFunction(this.$store.getters[this.getterPath]);
    },
    getterPath() {
      return `${this.moduleName}/${this.getterName}`;
    },
    setterPath() {
      return `${this.moduleName}/${this.setterName}`;
    },
    isValid() {
      if (this.mask === 'search') return null;
      if (!this.forceValidation) {
        if (!this.customValue || this.inputValidation(this.customValue) === null) return null;
      }
      return this.inputValidation(this.customValue);
    },
    validationClass() {
      if (this.isValid === null) return '';
      return this.isValid ? 'is-valid' : 'is-invalid';
    },
  },
  beforeMount() {
    const value = this.getterFunction(this.$store.getters[this.getterPath]);
    this.customValue = value;
  },
  mounted() {
    this.$emit('validation', this.isValid);
  },
  watch: {
    isValid: {
      handler(value) {
        this.$emit('validation', value);
      },
    },
  },
  methods: {
    setCustomModel(value) {
      this.customValue = value;
      this.debouncer.cancel();
      const debouncerFunction = () => {
        this.$store.dispatch(
          this.setterPath,
          this.setterFunction(value, this.path || this.getterName),
        );
        this.setterCallback();
      };
      this.debouncer = debounce(debouncerFunction, this.debounceTimer);
      this.debouncer();
    },
    isEmpty(value) {
      return value === '' || isNil(value) || Number.isNaN(value);
    },
  },
};
